import type { PresenceUser } from '@colplat/protocol';
import { escapeHtml } from './dom.js';

export function presenceDotHtml(user: PresenceUser, size = 16): string {
  return (
    `<span class="cf-dot" style="background:${escapeHtml(user.colorHex)};width:${size}px;height:${size}px" ` +
    `title="${escapeHtml(user.name)}" aria-hidden="true">${escapeHtml(user.initials)}</span>`
  );
}

export function presenceRowHtml(users: PresenceUser[], size = 16): string {
  return users.map((u) => presenceDotHtml(u, size)).join('');
}
